import { Button, Card, Menu, message, Spin } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import Text from 'antd/lib/typography/Text';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getCourseEnrolments } from '../../services/courseEnrolmentService';
import { deleteLearner, getLearners } from '../../services/learnerService';
import ActionHeader from '../Common/ActionHeader';
import Banner from '../Common/Banner';
import CreditsAdd from './Credits/AddCredits';
import CreditsRemove from './Credits/RemoveCredits';
import LearnerEdit from './LearnerEdit';
import LearnerInfo from './LearnerInfo';

function LearnerPage() {
  const { id } = useParams();
  const history = useHistory();

  const [learner, setLearner] = useState([]);
  const [creditsInfo, setCreditsInfo] = useState({
    totalCredit: 0,
    referralCredit: 0,
    giftCredit: 0
  });
  const [enrolments, setEnrolments] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [status, setStatus] = useState('LOADING');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isAddCreditModalOpen, setIsAddCreditModalOpen] = useState(false);
  const [isRemoveCreditModalOpen, setIsRemoveCreditModalOpen] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setStatus('LOADING');
    getLearners(0, 0, { learnerId: id })
      .then((response) => {
        if (response.data.paginatedList.length) {
          const resLearner = response.data.paginatedList[0];
          setLearner(resLearner);
          fetchEnrolments(resLearner.learnerId);
        } else throw new Error();
        setStatus('SUCCESS');
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
        setStatus('ERROR');
      });
  };
  function toggleAddCreditsModal() {
    setIsAddCreditModalOpen((prev) => !prev);
  }
  function toggleRemoveCreditsModal(){
    setIsRemoveCreditModalOpen((prev) => !prev);
  }
  const addCreditsSuccess = () => {
    message.success("Credits Added Successfully");
    setIsAddCreditModalOpen(false);
  };
  const removeCreditsSuccess = () => {
    message.success("Credits Removed Successfully");
    setIsRemoveCreditModalOpen(false);
  };

  const fetchEnrolments = (learnerId) => {
    getCourseEnrolments(0, 0, { learnerId: learnerId })
      .then((response) => {
        if (response.data.paginatedList.length)
          setEnrolments(response.data.paginatedList);
        setStatus('SUCCESS');
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
        setStatus('ERROR');
      });
  };

  useEffect(() => {
    let creditsInfo = {
      totalCredit: learner?.userCredits?.totalCredit || 0,
      referralCredit: learner?.userCredits?.referralCredit || 0,
      giftCredit: learner?.userCredits?.giftCredit || 0
    };
    creditsInfo.totalCredit = creditsInfo.totalCredit > 0 ? parseFloat(creditsInfo.totalCredit/100).toFixed(2) : 0;
    creditsInfo.referralCredit = creditsInfo.referralCredit > 0 ? parseFloat(creditsInfo.referralCredit/100).toFixed(2) : 0;
    creditsInfo.giftCredit = creditsInfo.giftCredit > 0 ? parseFloat(creditsInfo.giftCredit/100).toFixed(2) : 0;
    setCreditsInfo(creditsInfo);
  }, [learner]);

  const updateLearnerData = (values) => {
    setLearner((prev) => {
      return {
        ...prev,
        ...values,
      };
    });
  };

  function toggleEditModal() {
    setIsEditModalOpen((prev) => !prev);
  }

  async function deleteLearnerData() {
    await deleteLearner(id)
      .then(() => {
        alert('Learner Deleted Successfully!');
        history.push('/learners');
      })
      .catch(() => {
        alert('Cannot delete the learner right now!');
      });
  }

  const isSignedUp = () => !!learner?.isActive;

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={toggleEditModal}>Edit</Menu.Item>
      <Menu.Item onClick={() => setIsDeleteModalOpen(true)}>Delete</Menu.Item>
    </Menu>
  );

  if (status === 'LOADING') return <Spin size="large" />;

  if (status === 'ERROR')
    return (
      <Text type="danger">
        Something went wrong, Try Again or Contact Admin.
      </Text>
    );
  return (
    <div>
      <ActionHeader
        title={`Learner: ${learner.firstName} ${learner.lastName}`}
        actionMenu={actionMenu}
      />
      <div>
        <Card
        style={{ width: 300 }}
        actions={[
        <Button type="primary" onClick={toggleAddCreditsModal}>
          Add Credits
          </Button>,
          <Button type="primary" onClick={toggleRemoveCreditsModal} danger>
          Remove Credits
          </Button>
          ]}
          >
            <Card.Meta
            title="Credits Info"
            description={"total Credits: " + creditsInfo.totalCredit}
            />
            <Card.Meta
            description={"Gift Credits: " + creditsInfo.giftCredit}
            />
            <Card.Meta
            description={"Referral Credits: " + creditsInfo.referralCredit}
            />
            </Card>
            <CreditsAdd learner={learner} isOpen={isAddCreditModalOpen} onSuccess={addCreditsSuccess} toggle={toggleAddCreditsModal} />
            <CreditsRemove learner={learner} isOpen={isRemoveCreditModalOpen} onSuccess={removeCreditsSuccess} toggle={toggleRemoveCreditsModal} />
      </div>
      <br />
      {!isSignedUp() && <Banner message="User has not signed up." />}
      <LearnerInfo
        learner={learner}
        enrolments={enrolments}
        setSelectedRowKeys={setSelectedRowKeys}
        setSelectedRows={setSelectedRows}
      />
      <LearnerEdit
        learner={learner}
        isOpen={isEditModalOpen}
        toggle={toggleEditModal}
        updateLearnerData={updateLearnerData}
      />
      <Modal
        title="Delete Learner"
        visible={isDeleteModalOpen}
        onOk={deleteLearnerData}
        onCancel={() => setIsDeleteModalOpen(false)}
      >
        <p>Are you sure you want to delete the learner?</p>
      </Modal>
    </div>
  );
}

export default LearnerPage;
